import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Pinterest32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      d="M24.965 12.975c-.387-4.964-4.772-6.372-4.772-6.372-4.807-1.712-8.336.766-8.336.766-4.837 3.084-3.753 7.859-3.753 7.859.522 3.045 2.56 3.542 2.56 3.542.399.123.53-.29.53-.29l.325-1.29c.04-.162-.114-.334-.114-.334l-.272-.326c-.729-1.047-.68-2.358-.68-2.358.184-3.437 2.317-4.858 3.38-5.386 1.062-.52 4.293-1.343 6.637.695 2.344 2.037 1.102 6.38 1.102 6.38-.466 1.875-1.62 3.02-1.62 3.02-1.444 1.324-2.814.72-2.814.72-1.58-.668-1.234-2.186-1.234-2.186l.132-.528.29-1.012s.79-2.09.715-3.27c-.074-1.175-.913-1.984-2.344-1.588-1.43.396-1.712 2.385-1.712 2.385-.232 1.69.18 2.508.351 2.772l-.017.013-1.501 6.363c-.374 1.602-.374 2.517-.343 3.463.03.947.189 1.897.189 1.897.14.202.307 0 .307 0 1.743-2.227 2.164-3.776 2.164-3.776l.975-3.81c.57.924 1.409 1.219 1.409 1.219 3.095 1.324 5.781-1.193 5.781-1.193s3.06-2.411 2.665-7.375z"
      fill="#010101"
      fillRule="evenodd"
    />
  </svg>
);

export default Pinterest32;
